/* eslint import/no-extraneous-dependencies: 0 */
import * as Blockly from 'blockly';

// Transforms por tipo de bloque copiados del CSS de prod. En v13 la clase del tipo está en el <g>
// raíz del bloque, así que se usa un selector descendiente en vez del `+` del legacy.
// El ícono del piezo (15.svg) tiene mucho espacio vacío en su viewBox y hay que agrandarlo.
const PIEZO_BUZZER_ICON_TRANSFORM = 'scale(1.8) translate(-12px, -11px)';
const PIEZO_BUZZER_ICON_BLOCK_TYPES = [
  'BHOOT_piezo_buzzer',
  'BHOOT_piezo_buzzer_variable',
  'BHOOT_piezo_buzzerno',
  'IACO_piezo_buzzer',
  'IACO_piezo_buzzer_variable',
  'IACO_piezo_buzzerno',
  'microbit_play_melody_2',
];

Blockly.Css.register(
  PIEZO_BUZZER_ICON_BLOCK_TYPES
    .map((type) => `.${type} .blocklyImageField image { transform: ${PIEZO_BUZZER_ICON_TRANSFORM}; }`)
    .join('\n'),
);

// No usar `transform-origin: center`: duplica el alto del bloque. Se centra con translate(9px) =
// (60 - 60*0.7) / 2. Los tipos de esta lista deben mantener el field de imagen en 60x60: achicar el
// field en vez de escalar por CSS rompe el alto de la fila.
const LED_ICON_TRANSFORM = 'translate(9px, 9px) scale(0.7)';
const LED_ICON_BLOCK_TYPES = [
  'BHOOT_led_neopixel',
  'BHOOT_led_neopixel_clear',
  'BHOOT_led_neopixel_maxBrightness',
  'BHOOT_led_neopixel_planetario',
  'BHOOT_led_neopixel_clear_planetario',
  'planetario_reflector',
  'planetario_reflector_off',
  'luces_colon',
  'luces_colon_off',
  'luces_obelisco',
  'luces_obelisco_off',
  'ARDUINOUNO_servo_move_flor',
  'BHOOT_led_neopixel_flor',
  'BHOOT_led_neopixel_flor2',
  'BHOOT_led_neopixel_clear_flor',
  'BHOOT_led_neopixel_clear_flor2',
];

Blockly.Css.register(
  LED_ICON_BLOCK_TYPES
    .map((type) => `.${type} .blocklyImageField image { transform: ${LED_ICON_TRANSFORM}; }`)
    .join('\n'),
);

// Valores exactos de prod (la regla que gana por cascada); no reordenar scale/translate.
const MATRIX_ICON_TRANSFORM = 'scale(0.75) translate(8px, 13px)';
const MATRIX_ICON_BLOCK_TYPES = [
  'matrix8x8_text',
  'matrix8x16_text',
  'matrix8x8_draw',
];

Blockly.Css.register(
  MATRIX_ICON_BLOCK_TYPES
    .map((type) => `.${type} .blocklyImageField image { transform: ${MATRIX_ICON_TRANSFORM}; }`)
    .join('\n'),
);

const BHOOT_SERVO_MOVE_ICON_TRANSFORM = 'scale(0.8) translate(12px, 10px)';
const BHOOT_SERVO_MOVE_ICON_BLOCK_TYPES = [
  'BHOOT_servo_move',
  'BHOOT_servo_move_millis',
];

Blockly.Css.register(
  BHOOT_SERVO_MOVE_ICON_BLOCK_TYPES
    .map((type) => `.${type} .blocklyImageField image { transform: ${BHOOT_SERVO_MOVE_ICON_TRANSFORM}; }`)
    .join('\n'),
);

const BHOOT_SERVO_READ_ICON_TRANSFORM = 'scale(0.8) translate(12px, 8px)';

Blockly.Css.register(
  `.BHOOT_servo_read .blocklyImageField image { transform: ${BHOOT_SERVO_READ_ICON_TRANSFORM}; }`,
);

// camera.svg ocupa todo el alto del field: se achica y centra como el LED (field en 60x60).
const CAMERA_ICON_BLOCK_TYPES = [
  'CAMERA_face_detected',
  'CAMERA_color_detected',
  'CAMERA_shape_detected',
  'CAMERA_motion_detected',
  'CAMERA_color_position',
];

Blockly.Css.register(
  CAMERA_ICON_BLOCK_TYPES
    .map((type) => `.${type} .blocklyImageField image { transform: ${LED_ICON_TRANSFORM}; }`)
    .join('\n'),
);
